import { MultiString } from "../../../../library-js/i18n/MultiString";

export enum ActionType
{
  ADD_TO_CART,
  DOWNLOAD,
  OPEN,
  ON_STEAM
}

export class ActionTypes 
{
  static readonly [ ActionType.ADD_TO_CART ]:MultiString = 
  {
    en: "ADD TO CART"
  }

  static readonly [ ActionType.DOWNLOAD ]:MultiString = 
  {
    en: "DOWNLOAD"
  }

  static readonly [ ActionType.OPEN ]:MultiString = 
  {
    en: "OPEN"
  }

  static readonly [ ActionType.ON_STEAM ]:MultiString = 
  {
    en: "ON STEAM"
  }
}